export default "__VITE_ASSET__C_N_mNwr__"